<template>
  <div>
    <v-card flat class="mx-auto" v-for="(document, i) in documents" :key="i">
      <v-card-text>
        <v-toolbar
          color="primary"
          class="white--text text-capitalize text-body-1"
          dense
        >
          {{ document.fileName }}
          <v-spacer />
          <!-- Native iframe has its own download functionality -->
          <!-- <v-btn
            color="secondary"
            class="mx-2 text-capitalize"
            @click="openFile(document.base64Attachment)"
          >
            Download
            <v-icon class="mx-1">mdi-download</v-icon>
          </v-btn> -->
        </v-toolbar>

        <div v-if="document.fileExtension === 'pdf'">
          <!-- PDF Viewer Iframe (Desktop) / Mobile Placeholder -->
          <div
            class="pa-0 elevation-1 mb-1 mt-4"
            :style="{
              height: isMobile ? 'auto' : '80vh',
              minHeight: isMobile ? '300px' : '700px',
              position: 'relative',
              background: isMobile ? '#ffffff' : '#525659'
            }"
          >
            <!-- Loader while Blob URL is being created/loaded -->
            <div v-if="!pdfUrls[i]" class="pa-4 white" style="height: 100%">
              <v-skeleton-loader type="image" height="100%" />
            </div>

            <template v-else>
              <!-- Mobile Optimized View -->
              <div
                v-if="isMobile"
                class="pa-12 text-center d-flex flex-column align-center justify-center"
              >
                <v-icon size="100" color="primary lighten-4"
                  >mdi-file-pdf-box</v-icon
                >
                <div class="mt-6 grey--text text--darken-2 headline font-weight-bold">
                  Document Preview
                </div>
                <div class="mt-2 grey--text subtitle-1 mb-8">
                  Your document is ready. Since you are on a mobile device, please
                  use the button below to view it.
                </div>
                <v-btn
                  x-large
                  color="primary"
                  class="text-none px-8 rounded-lg shadow-lg"
                  @click="openPdfInNewTab(i)"
                >
                  <v-icon left>mdi-eye</v-icon>
                  Open Document
                </v-btn>
                <div class="mt-4 grey--text caption">
                  The document will open in your device's native PDF viewer.
                </div>
              </div>

              <!-- Desktop Iframe View -->
              <iframe
                v-else
                :src="pdfUrls[i]"
                width="100%"
                height="100%"
                frameborder="0"
                style="border: none; display: block"
                title="PDF Viewer"
                loading="lazy"
              ></iframe>
            </template>
          </div>
        </div>
        <div v-else-if="isImage(document.fileExtension)" class="mt-4">
          <v-img :src="document.base64Attachment" />
        </div>
        <div v-else class="mt-4">
          <v-card>
            <v-card-text>
              <div class="text-body-1">
                Sorry, we cannot display this file. Please download it to view it.
              </div>
            </v-card-text>
          </v-card>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
import FileMixin from "@/packages/cassandra-base/mixins/FileMixin";

export default {
  name: "ApprovalDocuments",
  mixins: [FileMixin],
  props: {
    documents: {
      type: Array,
      required: true,
    },
  },
  data: () => ({
    numPages: undefined,
    pdfUrls: {},
  }),
  computed: {
    isImage: function () {
      return (fileExtension) => {
        return (
          fileExtension === "jpg" ||
          fileExtension === "jpeg" ||
          fileExtension === "png"
        );
      };
    },
    isMobile() {
      // Production-grade mobile detection
      return (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        ) || window.innerWidth <= 768
      );
    },
  },
  watch: {
    documents: {
      immediate: true,
      handler(newDocs) {
        this.generateAllPdfUrls(newDocs);
      },
      deep: true,
    },
  },
  methods: {
    generateAllPdfUrls(docs) {
      // Revoke old URLs
      Object.values(this.pdfUrls).forEach((url) => URL.revokeObjectURL(url));
      const newUrls = {};

      docs.forEach((doc, index) => {
        if (doc.fileExtension === "pdf" && doc.base64Attachment) {
          try {
            // Check if it's already a data URL or just raw base64
            let base64Data = doc.base64Attachment;
            if (base64Data.includes("base64,")) {
              base64Data = base64Data.split("base64,")[1];
            }

            const binaryString = window.atob(base64Data.trim());
            const len = binaryString.length;
            const bytes = new Uint8Array(len);
            for (let i = 0; i < len; i++) {
              bytes[i] = binaryString.charCodeAt(i);
            }
            const blob = new Blob([bytes], { type: "application/pdf" });
            newUrls[index] = URL.createObjectURL(blob);
          } catch (e) {
            console.error("Error generating PDF URL for document " + index, e);
          }
        }
      });
      this.pdfUrls = newUrls;
    },
    openPdfInNewTab(index) {
      const url = this.pdfUrls[index];
      if (!url) return;
      window.open(url, "_blank");
    },
    openFile(filePath) {
      window.open(filePath, "_blank");
    },
  },
  beforeDestroy() {
    Object.values(this.pdfUrls).forEach((url) => URL.revokeObjectURL(url));
  },
};
</script>
<style scoped>
.shadow-lg {
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1),
    0 4px 6px -2px rgba(0, 0, 0, 0.05) !important;
}
</style>
